<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.organization-hierarchy.text") }}</h1>

      <div>
        <b-card no-body class="shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.organization-hierarchy.line-1") }}
            </p>
            <p class="mb-3">
              {{ $t("help.platform.organization-hierarchy.line-2") }}
            </p>

            <img src="@/assets/images/help/unit-hierarchy.png" class="image" />

            <p class="mb-3">
              {{ $t("help.platform.organization-hierarchy.line-3") }}
            </p>

            <img src="@/assets/images/help/unit-process-hierarchy.png" class="image" />

            <p class="mt-3 mb-3">
              {{ $t("help.platform.organization-hierarchy.line-4") }}
            </p>
          </b-card-body>
        </b-card>
        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>
                {{ $t("help.platform.organization-hierarchy.parent-unit.text") }}
              </div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.organization-hierarchy.parent-unit.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/parent-unit.png" class="image" />
              <p class="mt-3">
                {{ $t("help.platform.organization-hierarchy.parent-unit.line-2") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.organization-hierarchy.parent-unit.line-3") }}
              </p>
              <img src="@/assets/images/help/department.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>
                {{ $t("help.platform.organization-hierarchy.process.text") }}
              </div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.organization-hierarchy.process.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/process.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.organization-hierarchy.process.line-2") }}
              </p>
              <img src="@/assets/images/help/process-library-item.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.organization-hierarchy.process.line-3") }}
              </p>
              <img src="@/assets/images/help/process-recommendation.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.organization-hierarchy.process.line-4") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.organization-hierarchy.process.line-5") }}
              </p>

              <img src="@/assets/images/help/department-process.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.organization-hierarchy.process.line-6") }}
              </p>
              <img src="@/assets/images/help/process-recommendation-list.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
